import collapseDescription from '../../../../assets/svg/collapseDescription.svg';
import darkCollapseDescription from '../../../../assets/svg/collapseDescriptionDark.svg';
import FunctionButton from '../../../common/functionButton';

interface CollapseButtonProps {
  handleButtonClicked: () => void;
  variant?: string;
}

const CollapseButton = ({
  handleButtonClicked,
  variant,
}: CollapseButtonProps) => (
  <FunctionButton
    text={'Collapse'}
    handleButtonClicked={handleButtonClicked}
    icon={variant === 'dark' ? darkCollapseDescription : collapseDescription}
    customVariant={variant}
  />
);

export default CollapseButton;
